// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2bvSH","select":"Header_select__2N3P7","clinic":"Header_clinic__1q7aQ"};